// extracted by mini-css-extract-plugin
export default {"card":"inventory-activity_card__ukSPk","cardTitle":"inventory-activity_cardTitle__PWkpF"};